import * as React from 'react'
import ReactDOM from 'react-dom/client'

import { Paragraph } from '../../main/components'
import { Button } from '../../main/components/button'
import { Topbar } from '../maps/components/Topbar'
import { QueryClientContext } from '../shared/components/QueryClientContext'
import { Share } from './Share'
import BubbleActionCreators from './actions/bubbleActionCreators'
import { BubbleChart } from './bubbleChart'
import BubblesHover from './bubblesHover'
import { BUBBLES_SETTINGS } from './constants/settings'
import { Presets } from './presets'
import { ETF_INDUSTRY_IDS, ETF_SECTOR_VALUE, MARKET_CAP_VALUE } from './selects'
import { SidebarContent } from './sidebar'
import { BubblesLoadParam } from './types'
import { decodeQueryString, encodeQueryString } from './utils'

const linkClassName = 'text-link hover:text-gray-50'

function Bubbles() {
  const queryString = decodeQueryString(true)
  const hasETFsEnabled =
    // Index isn’t set
    queryString.idx === 'any' &&
    // Sector isn’t set or is specifically set to financial sector
    (!queryString.ind || queryString.ind === 'any' || ETF_INDUSTRY_IDS.includes(queryString.ind)) &&
    // Industry isn’t set or is specifically set to an ETF industry
    (!queryString.sec || queryString.sec === 'any' || queryString.sec === ETF_SECTOR_VALUE)

  const onChange = React.useRef((values: any) => {
    let query = encodeQueryString(values)

    if (query.length) query = `?${query}`

    document.location.href = `/bubbles.ashx${query}`
  }).current

  return (
    <div>
      <Topbar
        className="border-finviz-blue-gray bg-[#363a46] text-[#94a3b8] shadow"
        navContent={
          <>
            <h2 className="m-0 text-2xs uppercase opacity-50">View</h2>
            <Button as="a" href="/map.ashx" leftContent="chartTreemap" theme="transparent" className={linkClassName}>
              Map
            </Button>
            <Button as="a" href="/bubbles.ashx" leftContent="chartBubble" theme="transparent" className="text-gray-50">
              Bubbles
            </Button>
          </>
        }
        mapControls={
          <div className="pr-2">
            <Share extendedFilters className={linkClassName} />
          </div>
        }
      >
        {hasETFsEnabled && queryString.size === MARKET_CAP_VALUE && (
          <Paragraph size="small" className="leading-tight">
            ETF size represents assets under management.
          </Paragraph>
        )}
      </Topbar>
      <div className="bubbles-container">
        <div className="sidebar w-[200px]">
          <div className="mb-0.5 bg-[#404553] p-5 pt-3">
            <div className="border-b border-gray-700">
              <div className="-mx-2 mb-1 flex items-center justify-between py-1">
                <Presets isDark className={linkClassName} />
                <Button theme="transparent" className={linkClassName} onClick={() => onChange({})}>
                  Reset
                </Button>
              </div>
            </div>
            <SidebarContent
              hasETFs={hasETFsEnabled}
              extendedFilters
              selected={queryString}
              onChange={onChange}
              linkClassName={linkClassName}
            />
          </div>
        </div>
        <div className="flex flex-1 flex-col">
          <div id="map">
            <div id="body" className="relative">
              <BubbleChart settings={BUBBLES_SETTINGS} />
              <BubblesHover
                labelX={queryString['x']}
                labelY={queryString['y']}
                labelSize={queryString['size']}
                labelColor={queryString['color']}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

window['FinvizInitBubbles'] = function () {
  BubbleActionCreators.load('/api/bubbles.ashx', decodeQueryString(true) as unknown as BubblesLoadParam)
  const rootEl = document.getElementById('bubbles')
  if (rootEl) {
    const root = ReactDOM.createRoot(rootEl)
    root.render(
      <QueryClientContext>
        <Bubbles />
      </QueryClientContext>
    )
  }
}
